import React from 'react'
import { Card as MuiCard } from "@mui/material"
import { CARD } from "../modules/constants"

const Card = ({ variant = 'default', children, ...props }) => {
  const variants = {
    default: {
    },
    card: {
      width: "96%",
      marginLeft: "auto",
      marginRight: "auto",
      marginBottom: "20px",
      border: CARD.BORDER,
    },
  }

  return (
    <MuiCard sx={{ ...variants[variant] }} {...props}>
      {children}
    </MuiCard>
  )
}

export default Card